import { makeStyles, Skeleton, SkeletonItem, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  shell: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    backgroundColor: 'var(--hts-app-bg)',
  },
  // Same geometry as the real Header: 64px navy bar (the safe-area strip is
  // additive in the native shell; the skeleton doesn't need pixel-exact
  // height — it needs to read as "the shell is here, content is coming").
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    height: 'calc(64px + max(env(safe-area-inset-top, 0px), var(--hts-safe-top, 0px)) + 4px)',
    paddingTop: 'calc(max(env(safe-area-inset-top, 0px), var(--hts-safe-top, 0px)) + 4px)',
    boxSizing: 'border-box',
    flexShrink: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
    backgroundColor: 'var(--hts-shell-bg)',
  },
  headerTitle: {
    width: '140px',
  },
  headerRight: {
    marginLeft: 'auto',
    width: '120px',
  },
  body: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  rail: {
    width: '72px',
    flexShrink: 0,
    backgroundColor: 'var(--hts-shell-bg)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '18px',
    paddingTop: '16px',
  },
  railItem: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
  },
  content: {
    flex: 1,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: 0,
  },
  titleBar: {
    height: '28px',
    width: '220px',
  },
  card: {
    height: '120px',
    borderRadius: '8px',
    backgroundColor: tokens.colorNeutralBackground1,
  },
});

/**
 * Shell-shaped loading skeleton — replaces the full-screen spinner loading
 * screens (MSAL init, auth resolution, lazy route chunks) with a preview of
 * the interface that's about to appear: navy header, nav rail, and shimmering
 * content cards. Same skeleton everywhere (web + native iPad) so the load
 * reads as "the app assembling" instead of "a spinner hoping for the best".
 */
export function AppSkeleton() {
  const styles = useStyles();
  return (
    <div className={styles.shell} role="status" aria-label="Loading">
      <div className={styles.header}>
        <SkeletonItem className={styles.headerTitle} />
        <SkeletonItem className={styles.headerRight} />
      </div>
      <div className={styles.body}>
        <div className={styles.rail}>
          {Array.from({ length: 5 }, (_, i) => (
            <SkeletonItem key={i} className={styles.railItem} />
          ))}
        </div>
        <div className={styles.content}>
          <SkeletonItem className={styles.titleBar} />
          <Skeleton className={styles.card} />
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            {Array.from({ length: 3 }, (_, i) => (
              <Skeleton key={i} style={{ flex: '1 1 220px', height: '96px' }} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppSkeleton;
